<div class="dropdown" [class.open]="isOpen">
	<div class="dropdown-header" (click)="toggleDropdown()">
		@if (selectedCount === 0) {
			<span>{{ 'channels.all_channels' | translate }}</span>
		} @else {
			<span
				>{{ selectedCount }}
				{{ 'channels.selected_channels' | translate }}</span
			>
		}
		<img
			class="arrow"
			[class.rotated]="isOpen"
			src="assets/arrow_dropdown.svg"
			alt
		/>
	</div>
	<div class="dropdown-menu" *ngIf="isOpen">
		<div class="item button" (click)="showAll()">
			<div class="checkbox none" [class.checked]="selectedCount === 0"></div>
			{{ 'channels.show_all' | translate }}
		</div>
		<div
			class="item"
			*ngFor="let channel of channels"
			(click)="toggleChannel(channel)"
		>
			<div class="checkbox" [class.checked]="channel.selected"></div>
			<span class="channel-icon" [ngClass]="channel.icon"></span>
			{{ channel.label | translate }}
		</div>
	</div>
</div>
